/**
 * Transforme la première lettre d'une phrase en majuscule
 */
export const capitalizeFirstLetter = (str: string): string => str.replace(/^./, (letter) => letter.toUpperCase());
